import { getListDataFunctionFactory } from '../../modules/getListDataFunctionFactory'
import type { TEntityId, ISelectItem } from '~/types/models'
import type { IGroup } from '~/types/group/models'
import {
  getGroupStatusById,
  GroupStatusIds,
} from '@/services/selectLists/groupStatii'

const groupListData = undefined as unknown as IGroup[]

export const getGroupListData = getListDataFunctionFactory<IGroup[]>({
  listData: groupListData,
  storageKey: 'groups',
  getStartingListData: getStartingGroupListData,
})

export async function getGroupData(id: string): Promise<IGroup | undefined> {
  const list = getGroupListData()
  return list.find((g: IGroup) => g.id === id)
}

export async function getGroupSelectData(id: TEntityId): Promise<ISelectItem> {
  const groupData = await getGroupData(id)
  if (!groupData) {
    throw new Error(`getGroupSelectData returned undefined/null`)
  }
  return { id: groupData.id, label: groupData.descr }
}

export async function getStartingGroupListData(): Promise<IGroup[]> {
  return [
    {
      id: 'XXG0001',
      hrid: 'G0001',
      descr: 'Metropolis Bank',
      groupsThisGroupCanSee: [{ id: 'XXG0001', label: 'Metropolis Bank' }],
      groupsThatCanSeeThisGroup: [{ id: 'XXG0002', label: 'WXTG' }],
      status: getGroupStatusById(GroupStatusIds.ACTIVE),
      version: '1',
      canBeDeleted: false,
    },
    {
      id: 'XXG0002',
      hrid: 'G0002',
      descr: 'WXTG',
      groupsThisGroupCanSee: [
        { id: 'XXG0001', label: 'Metropolis Bank' },
        { id: 'XXG0002', label: 'WXTG' },
        { id: 'XXG0003', label: 'Far Reaching Health' },
      ],
      groupsThatCanSeeThisGroup: [{ id: 'XXG0002', label: 'WXTG' }],
      status: getGroupStatusById(GroupStatusIds.ACTIVE),
      version: '1',
      canBeDeleted: false,
    },
    {
      id: 'XXG0003',
      hrid: 'G0003',
      descr: 'Far Reaching Health',
      groupsThisGroupCanSee: [{ id: 'XXG0003', label: 'Far Reaching Health' }],
      groupsThatCanSeeThisGroup: [{ id: 'XXG0002', label: 'WXTG' }],
      status: getGroupStatusById(GroupStatusIds.ACTIVE),
      version: '1',
      canBeDeleted: false,
    },
  ]
}
